import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FbSubmitModalConfiguration } from './fb-batchsubmit-modal.component.configuration';
import { UserController } from 'src/app/_core/controllers/user.controller';
import { ProfileDTO } from 'src/app/_core/classes/ProfileDTO';
import { CompanyPlaceDTO } from 'src/app/_core/classes/CompanyPlaceDTO';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PnNumberControlConfiguration } from '../controls/pn-number-control/pn-number-control.configuration';
import { RankingBidDTO, RankingController } from 'src/app/_core/controllers/ranking.controller';
import { IAddress } from 'src/app/pages/auction/create-auction/step1/step1.component';



@Component({
    selector: 'app-indirizzo-modal',
    templateUrl: './fb-batchsubmit-modal.component.html',
    styleUrls: ['./fb-batchsubmit-modal.component.scss'],
})
export class FbBatchsubmitModalComponent implements OnInit {

    config!: FbSubmitModalConfiguration;
    address: IAddress[] = [];
    profileInfoDTO: ProfileDTO | null = null;
    Places: Array<CompanyPlaceDTO> = [];
    formattedAddresses: any;
    offerInputConfiguration: PnNumberControlConfiguration;
    form: FormGroup;

    constructor(private formBuilder: FormBuilder,public rankingController : RankingController,public ref: DynamicDialogRef, public configuration: DynamicDialogConfig, private controller: UserController,private messageService : MessageService) {

        this.config = new FbSubmitModalConfiguration(configuration.data.modalConfig.Oid,configuration.data.modalConfig.AuctionName, configuration.data.modalConfig.StartingPrice, configuration.data.modalConfig.BidQuantity);

        if (configuration.data.modalConfig.Address) this.config.setAddress(configuration.data.modalConfig.Address);

        if(configuration.data.modalConfig.Offer)
        {

            this.config.setOffer(configuration.data.modalConfig.Offer);
            this.offerInputConfiguration = PnNumberControlConfiguration.create('Rilancia per non perdere l\'Asta:', 'number', 'offer').setControl(new FormControl(this.configuration.data.modalConfig.Offer + 1, [Validators.required,Validators.min(configuration.data.modalConfig.Offer)]));

        }
        else{

            this.offerInputConfiguration = PnNumberControlConfiguration.create('Partecipa all\'Asta:', 'number', 'offer').setControl(new FormControl(this.configuration.data.modalConfig.StartingPrice, [Validators.required,Validators.min(1)]));


        }

        this.form = this.formBuilder.group({
            Address: [null, Validators.compose([Validators.required])],
        })


    }

    generateSubtitle(){

        return 'Stai per offrire ' + this.offerInputConfiguration.Control.value * this.config.BidQuantity + '€ totali, ' + this.offerInputConfiguration.Control.value + '€ per ogni lotto puntato (' + this.config.BidQuantity +').'

    }
    async ngOnInit() {

        if (this.config.Address == null) {

            this.profileInfoDTO = await this.controller.getUserInfo();
            this.Places = this.profileInfoDTO?.Company?.Places

            if (this.Places && this.Places.length > 0) {

                this.Places.forEach(place => {

                    this.address.push({
                        label: place.Name + ", " + place.City + ", " + place.PostalCode,
                        value:  place.Oid
                    });

                });

                if(this.Places.length == 1) 
                {

                    this.form.patchValue({ Address: this.address });

                }

            }

        }
    }

    async onSubmit() {

        if((this.form.valid || this.config.Address) && this.offerInputConfiguration.Control.valid){

            const param : RankingBidDTO = new RankingBidDTO(this.config.Oid,this.offerInputConfiguration.Control.value, this.config.BidQuantity);

            if(this.form.valid){

                param.PlaceOid = this.form.get('Address')?.value[0]?.value;

            }

            const ret = await this.rankingController.bid(param);

            this.ref.close(true);

        }
        else{

            let detail = 'Qualcosa è andato storto, riprova.';

            if(!this.offerInputConfiguration.Control.valid) detail = 'L\' importo selezionato non è valido!'
            if(!this.form.valid && this.config.Address == null) detail = 'Selezionare un indirizzo!'

            this.messageService.add({
                severity: 'error',
                summary: 'Attenzione!',
                detail: detail
            });

        }

    }

    bid(value : number){

        this.offerInputConfiguration.Control.setValue((this.config.Offer ?? this.config.StartingPrice) + value);

    }
}
